import Vue from "vue";
import Vuex from "vuex";

import appPackage from "../../package.json";

import Member from "./modules/member";
import Menu from "./modules/menu";
import Store from "./modules/store";

Vue.use(Vuex);

export default new Vuex.Store({
  components: {
    appPackage,
  },

  modules: {
    Member,
    Menu,
    Store,
  },

  state: {
    originUrl: "",
    apiUrl: "https://api.mrsdigi.com/doapi/",
    doApiUrl: "",
    dcApiUrl: "",
    stripeApiUrl: "",
    gpApiUrl: "",

    httpReqOpt: { withCredentials: true },

    appPackage: appPackage,
    appSessionID: "",
    appSessionKey: "",
    appSessionIDModifiedTime: new Date(),
    appBar: {
      showDrawer: false,
    },
    appToken: null,
    appLogoSrc: null,
    appTabBarIndex: 0,

    kernelNo: 168,

    testMode: false,
    testPhoneNo: "",

    membershipCardLogoSrc: null,

    phonePattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
    postalPattern: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
    emailPattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
    decimalPattern: /^(\d*\.)?\d{0,2}$/,
    numberPattern: /[+-]?\d+(?:\.\d+)?/g,

    routeFrom: null,
    //routeTo: undefined,

    deviceInfo: null,

    OT_DINEIN: "dinein",
    OT_TAKEOUT: "takeout",
    OT_DELIVERY: "delivery",
    OT_KIOSK: "kiosk",

    launchTime: new Date(),
    rootName: null,

    companyName: "",
    service: null,
    myCoords: null,

    stores: {
      header: "",
      list: [],
      sortBy: "distance",
      addShortcutBarEnabled: false,
    },

    store: null,
    storeOrderHours: null,

    serverBuildNo: 0,
    mainMenu: [],

    orderMenu: 0,
    menu: [],
    items: [],
    redeemMenu: [],
    redeemItems: [],
    promos: [],
    newsFeeds: [],
    orderedCounter: [],
    termsOfUseContent: null,

    paymentCurrency: "CAD",
    paymentTips: [],
    doorDashTips: [
      {
        title: "10%",
        value: 10,
        rate: true,
        checked: false,
        other: false,
      },
      {
        title: "15%",
        value: 15,
        rate: true,
        checked: true,
        other: false,
      },
      {
        title: "20%",
        value: 20,
        rate: true,
        checked: false,
        other: false,
      },
      {
        title: "Other",
        value: 15,
        rate: true,
        checked: false,
        other: true,
      },
    ],

    order: {
      orderType: "",
      tableID: 0,
      tableName: "",
      tableGroupID: 0,
      tableGroupName: "",
      phoneID: "",
      memberCode: "",
      login: null,
      orderItems: [],
      currency: "",
      subtotal: 0,
      defaultDiscountRate: 0,
      defaultServiceValue: 0,
      defaultServicePercentage: true,
      deliveryValueByAddress: 0,
      deliveryWithhold: 0,
      deliveryValue: 0,
      discountRate: 0,
      discountValue: 0,
      tax: 0,
      tips: 0,
      total: 0,
      qtyTotal: 0,
      redeemedPointsTotal: 0,
      payAmount: 0,
      payData: {},
      address: {},
      dineInAway: false,
      checkoutTime: null,
      pickupTime: null,
      deliveryTime: null,
      memo: null,
      minOrder: 0,
      minOrderForFreeDelivery: 0,
      utensils: false,
      priceLevel: 0,
      distance: 0,
      payment: "",
      lastUpdated: new Date(),
      cbRefIDs: [],
      paymentTips: [],
      orderNow: true,
    },
    prevOrderType: "",

    descrIndex: 0,
    orderLimitPerPeriod: 0,
    orderLimitSkipValue: 0,
    menuImageVisible: "show",
    menuImageAlignment: "left",
    itemFastAdd: false,
    notAskUtensils: false,
    utensils: true,
    alwaysSendPickupTime: false,
    memoAsBillMemo: false,
    showItemBarcode: false,
    showItemImageInOrder: false,
    verifyPhoneNumber: false,
    languages: [],
    languageSelected: null,
    ordDidCount: 1,

    memberEnabled: false,
    memberOptional: false,
    pointEnabled: false,
    pointRedeemEnabled: false,
    giftcardEnabled: false,
    giftcardPaymentEnabled: false,
    giftcards: [],
    giftcardBalance: 0,
    member: null,
    guest: { name: "", phone1: "", phoneVerified: false },
    loginAsGuest: false,
    addressLookupEnabled: false,

    sideComboTags: [],
    addressList: [],

    orderHistory: [],

    theme: {
      primary: "#575761",
      secondary: "#648381",
      accent: "#cc4c7c",

      info: "#FFBF46",
      success: "#FFBF46",

      warning: "#c3073f",
      error: "#c3073f",

      primaryText: "#ffffff",
      secondaryText: "#ffffff",
      accentText: "#ffffff",
      infoText: "#000000",
      warningText: "#ffffff",
    },

    // for force update
    cartKey: 0,
  },

  getters: {
    platform: state => {
      if (state.deviceInfo == null || state.deviceInfo.platform === undefined) return null;
      else return state.deviceInfo.platform;
    },

    isNativeApp: (state, getters) => {
      return getters.platform != null && (getters.platform == "android" || getters.platform == "ios");
    },

    appName: state => {
      return state.appPackage.name;
    },

    appVersion: state => {
      let verData = state.appPackage.version.split(".");
      let version = {
        version: state.appPackage.version,
        buildNo: parseInt(verData[verData.length - 1]),
      };
      return version;
    },

    appInfo: (state, getters) => {
      return {
        name: getters.appName,
        buildNo: getters.appVersion.buildNo,
        kernelNo: state.kernelNo,
        serverBuildNo: state.serverBuildNo,
      };
    },

    storageKey: (state, getters) => {
      if (Vue.prototype.$appMode == 1) {
        return state.appToken.CompanyCode;
      } else {
        return getters.storeCompanyCode;
      }
    },

    acceptOrder: state => {
      //if (Vue.prototype.$devEnv) return true;

      let n_acceptOrder = true;
      if (state.storeOrderHours != null) {
        if (state.storeOrderHours.acceptOrder !== undefined) {
          n_acceptOrder = state.storeOrderHours.acceptOrder;
        }
      }

      return n_acceptOrder;
    },

    checkOrderLimit: state => {
      return (
        state.orderLimitPerPeriod > 0 &&
        (state.orderLimitSkipValue == 0 ||
          state.orderLimitSkipValue >= state.order.subtotal - state.order.discountValue)
      );
    },

    orderHistoryOnCloud: state => {
      return state.memberEnabled && !state.memberOptional;
    },

    orderFrom: (state, getters) => {
      let orderFrom = "";
      if (state.order.orderType == state.OT_DINEIN && getters.storeDineinMenuMode) orderFrom = "dinein.menu";
      else if (state.order.tableID > 0 && state.order.tableName != "") {
        orderFrom = state.order.tableName;
      } else if (state.order.tableGroupID > 0 && state.order.tableGroupName != "") {
        orderFrom = state.order.tableGroupName;
      } else {
        orderFrom = state.order.orderType;
      }

      return orderFrom;
    },

    service: state => {
      if (Vue.prototype.$appMode == 1) {
        return state.service;
      } else {
        if (state.store == null || state.store.service == null) return null;
        else return state.store.service;
      }
    },

    serviceSessionKey: (state, getters) => {
      if (getters.service == null) return null;
      else return getters.service.sessionKey;
    },

    serviceCompanyCode: (state, getters) => {
      if (getters.service == null) return null;
      else return getters.service.companyCode;
    },

    newsFeedsVisible: state => {
      return state.newsFeeds.length > 0;
    },

    checkoutPickupTimeIgnored: (state, getters) => {
      if (
        !getters.doorDashEnabled &&
        state.order != null &&
        state.order.orderType != null &&
        getters.storeOrderTypes != null
      ) {
        if (state.order.orderType == state.OT_DINEIN) {
          return true;
        } else if (state.order.orderType == state.OT_TAKEOUT && getters.storeOrderTypes.takeout != null) {
          if (getters.storeOrderTypes.takeout.pickupTimeIgnored != null)
            return getters.storeOrderTypes.takeout.pickupTimeIgnored;
          else return false;
        } else if (state.order.orderType == state.OT_DELIVERY && getters.storeOrderTypes.delivery != null) {
          if (getters.storeOrderTypes.delivery.deliveryTimeIgnored != null)
            return getters.storeOrderTypes.delivery.deliveryTimeIgnored;
          else return false;
        } else return false;
      } else return false;
    },

    doorDashEnabled: (state, getters) => {
      if (
        state.order != null &&
        state.order.orderType != null &&
        state.order.orderType == state.OT_DELIVERY &&
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.delivery.doorDashEnabled != null
      )
        return getters.storeOrderTypes.delivery.doorDashEnabled;
      else return false;
    },

    ftsTechEnabled: (state, getters) => {
      if (
        state.order != null &&
        state.order.orderType != null &&
        state.order.orderType == state.OT_DELIVERY &&
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.delivery.ftsTechEnabled != null
      )
        return getters.storeOrderTypes.delivery.ftsTechEnabled;
      else return false;
    },

    faceDriveEnabled: (state, getters) => {
      if (
        state.order != null &&
        state.order.orderType != null &&
        state.order.orderType == state.OT_DELIVERY &&
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.delivery.faceDriveEnabled != null
      )
        return getters.storeOrderTypes.delivery.faceDriveEnabled;
      else return false;
    },

    todayServeTime: state => {
      let _todayServeTime = null;
      if (state.storeOrderHours != null && state.storeOrderHours != null) {
        if (state.storeOrderHours.serveTime != null) {
          _todayServeTime = state.storeOrderHours.serveTime;
        }
      }
      return _todayServeTime;
    },

    todayServeTimeString: getters => {
      let _todayServeTime = getters.todayServeTime;
      let _todayServeTimeString = "";
      if (_todayServeTime != null && _todayServeTime.timeFrom != _todayServeTime.timeTo) {
        _todayServeTimeString = _todayServeTime.timeFrom + "-" + _todayServeTime.timeTo;
      }
      return _todayServeTimeString;
    },

    availablePromos: state => {
      let redeemedPromoOIs = state.order.orderItems.filter(oi => oi.promo != null);
      let redeemedPromoCodes = [];
      if (redeemedPromoOIs != null) {
        redeemedPromoOIs.forEach(oi => {
          redeemedPromoCodes.push(oi.promo.PromoteCode);
        });
      }
      if (state.promos == null) return [];
      else
        return state.promos.filter(
          promo =>
            !redeemedPromoCodes.includes(promo.PromoteCode) &&
            (promo.CustomData == null ||
              promo.CustomData.OrderTypes == null ||
              promo.CustomData.OrderTypes.includes(state.order.orderType) ||
              state.order.orderType == "") &&
            (promo.CustomData == null || promo.CustomData.Hide == null || !promo.CustomData.Hide)
        );
    },

    languages: state => {
      if (Vue.prototype.$appMode == 1) {
        return state.languages;
      } else {
        if (state.store == null || state.store.info == null || state.store.info.languages == null) {
          return [];
        } else {
          return state.store.info.languages;
        }
      }
    },

    // eslint-disable-next-line
    launchMin: state => x => {
      let currentTime = new Date();
      let launchMin = (currentTime.getTime() - state.launchTime.getTime()) / 1000 / 60;

      return launchMin;
    },
  },

  mutations: {
    stores(state, payload) {
      if (payload.list != null) state.stores.list = payload.list;
      if (payload.sortBy != null) state.stores.sortBy = payload.sortBy;
      if (payload.header != null) state.stores.header = payload.header;
      if (payload.addShortcutBarEnabled != null) state.stores.addShortcutBarEnabled = payload.addShortcutBarEnabled;
    },

    theme(state, theme) {
      if (theme == null) return;

      if (theme.primary != null) {
        state.theme.primary = theme.primary;
      }
      if (theme.secondary != null) {
        state.theme.secondary = theme.secondary;
      }
      if (theme.accent != null) {
        state.theme.accent = theme.accent;
      }
      if (theme.info != null) {
        state.theme.info = theme.info;
      }
      if (theme.success != null) {
        state.theme.success = theme.success;
      }
      if (theme.warning != null) {
        state.theme.warning = theme.warning;
      }
      if (theme.error != null) {
        state.theme.error = theme.error;
      }
      if (theme.primaryText != null) {
        state.theme.primaryText = theme.primaryText;
      }
      if (theme.secondaryText != null) {
        state.theme.secondaryText = theme.secondaryText;
      }
      if (theme.accentText != null) {
        state.theme.accentText = theme.accentText;
      }
      if (theme.infoText != null) {
        state.theme.infoText = theme.infoText;
      }
      if (theme.warningText != null) {
        state.theme.warningText = theme.warningText;
      }
    },

    giftcards(state, payload) {
      state.giftcards = payload;
    }
  },
  actions: {},
});
